module.exports = __webpack_public_path__ + "static/img/designGuide5.018515f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide5.png
// module id = kljB
// module chunks = 2